import React from 'react';
import SidebarItems from './SidebarItems';

const Sidebar = () => {
  return (
    <div className="bg-[#143d7d] w-20 flex flex-col">
      {/* Sidebar Header */}
      <div className="flex justify-center mt-5 mb-6">
        <img src="/images/sidebar_logo.png" alt="logo" className="w-10 h-10 object-contain mt-1" />
      </div>

      {/* Sidebar Items */}
      <div className="flex-1 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
        <SidebarItems />
      </div>
    </div>
  );
};

export default Sidebar;
